import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.css']
})
export class ChangePasswordFormComponent implements OnDestroy, OnInit {

  @Input() editMode: boolean = true;
  @Input() appearance: 'outline' | 'fill' | 'standard' = 'outline';

  formGroup: FormGroup;

  displayPasswords = {
    oldPassword: false,
    newPassword: false,
    confirmPassword: false
  }

  private _subscriptions: Subscription[] = [];

  constructor(
    private _controlContainer: ControlContainer
  ) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as FormGroup;

    this._subscriptions.push(...[
      this.formGroup.statusChanges.subscribe(() => this.formGroup.controls['confirmPassword'].setErrors(this.formGroup.errors, { emitEvent: false }))
    ]);

    this.setValidators();
  }

  setValidators() {
    this.formGroup.controls['newPassword'].setValidators(Validators.compose([Validators.required, Validators.minLength(8)]));
    this.formGroup.setValidators(confirmPasswordEqualsNewPassword);
  }

}

const confirmPasswordEqualsNewPassword: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const newPassword = (control as FormGroup).controls['newPassword'].value;
  const confirmPassword = (control as FormGroup).controls['confirmPassword'].value;
  return newPassword === confirmPassword ? null: { passwordMismatch: true };
};
